exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "img.logo-left[data-v-d49b74f8]{width:108px;height:auto}h4[data-v-d49b74f8]{font-family:Quicksand,Sans-Serif,serif;font-weight:400;font-size:16px}h4[data-v-d49b74f8]:first-child{margin-top:12px}", ""]);
